import { render, staticRenderFns } from "./ErneuerbareEnergienIcon.vue?vue&type=template&id=68b73b5e&scoped=true&"
var script = {}
import style0 from "./ErneuerbareEnergienIcon.vue?vue&type=style&index=0&id=68b73b5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b73b5e",
  null
  
)

export default component.exports